import { tableSchema } from '@nozbe/watermelondb'

/* 
  ------------ IMPORTANTE ------------
  
  EM CASO DE MUDANÇA NO SCHEMA FAZER MIGRAÇÃO SEGUINDO PIPELINE DA DOC
  https://watermelondb.dev/docs/Advanced/Migrations

  ------------ IMPORTANTE ------------
*/

export default {
  version: 23,
  tables: [
    tableSchema({
      name: 'chats',
      columns: [
        { name: 'session_id', type: 'number', isIndexed: true },
        { name: 'chat_id', type: 'string', isIndexed: true },
        { name: 'connection_key', type: 'string', isIndexed: true },
        { name: 'client_name', type: 'string' },
        { name: 'client_code', type: 'string', isOptional: true },
        { name: 'client_summary', type: 'string', isOptional: true },
        { name: 'client_summary_at', type: 'number', isOptional: true },
        { name: 'is_client_summarizing', type: 'boolean' },
        { name: 'is_archived', type: 'boolean' },
        { name: 'unreads', type: 'number' },
        { name: 'destination_description', type: 'string', isOptional: true },
        { name: 'first_contact_at', type: 'number', isOptional: true },
        { name: 'contact_at', type: 'number' },
        { name: 'formatted_phone_number', type: 'string' },
        { name: 'is_highlighted', type: 'boolean' },
        { name: 'last_message', type: 'string' },
        { name: 'last_message_source', type: 'string' },
        { name: 'last_message_type', type: 'string' },
        { name: 'last_message_user_name', type: 'string' },
        { name: 'phone_number', type: 'string', isIndexed: true },
        { name: 'session_state', type: 'string' },
        { name: 'is_show_message_user_name', type: 'boolean' },
        { name: 'user_id', type: 'string' },
        { name: 'user_name', type: 'string' },
        { name: 'vendor', type: 'string' },
        { name: 'minutes_to_block', type: 'number' },
        { name: 'is_blocked', type: 'boolean' },
        { name: 'destination', type: 'string', isOptional: true },
        { name: 'normalized_search', type: 'string' },
        { name: 'key', type: 'string', isIndexed: true },
        { name: 'has_client_message', type: 'boolean' },
        { name: 'is_contact_blocked', type: 'boolean' },
        { name: 'tags', type: 'string', isOptional: true },
        { name: 'is_last_session', type: 'boolean' },
        { name: 'is_owner', type: 'boolean' },
        { name: 'is_ai_session', type: 'boolean' },
        { name: 'show_client_summary', type: 'boolean' },
        { name: 'is_chat_key', type: 'boolean' },
        { name: 'use_assistant', type: 'boolean' },
        { name: 'department', type: 'string', isOptional: true }
      ]
    }),
    tableSchema({
      name: 'messages',
      columns: [
        { name: 'chat_id', type: 'string', isIndexed: true },
        { name: 'connection_key', type: 'string' },
        { name: 'phone_number', type: 'string' },
        { name: 'text', type: 'string' },
        { name: 'name', type: 'string' },
        { name: 'message_id', type: 'string', isIndexed: true },
        { name: 'flow_id', type: 'string', isOptional: true },
        { name: 'media_id', type: 'number', isOptional: true },
        { name: 'at', type: 'number' },
        { name: 'status', type: 'string' },
        { name: 'source', type: 'string' },
        { name: 'type', type: 'string' },
        { name: 'user_id', type: 'string', isOptional: true },
        { name: 'user_name', type: 'string', isOptional: true },
        { name: 'medias', type: 'string', isOptional: true },
        { name: 'status_details', type: 'string' },
        { name: 'header', type: 'string' },
        { name: 'header_media_url', type: 'string', isOptional: true },
        { name: 'footer', type: 'string' },
        { name: 'buttons', type: 'string' },
        { name: 'contacts', type: 'string', isOptional: true },
        { name: 'location', type: 'string' },
        { name: 'order_details', type: 'string' },
        { name: 'reply_message', type: 'string', isOptional: true },
        { name: 'source_url', type: 'string', isOptional: true },
        { name: 'source_type', type: 'string', isOptional: true }
      ]
    })
  ]
}
